import React, {createContext, useState} from 'react';

import AppHeader from './AppHeader';
import AppContent from './AppContent';
import AppFooter from './AppFooter';

export const AppContext = createContext({});

export default function Layout() {
    const [contextValue, setContextValue] = useState({
    });

    return (
        <AppContext.Provider value={contextValue}>
            <AppHeader setContextValue={setContextValue}/>
            <AppContent />
            <AppFooter />
        </AppContext.Provider>
    );
}
